import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {FieldDefinition} from "@shared/models/field-definition";

@Component({
    standalone: false,
    selector: 'particle-cbc-string-cell-viewer',
  templateUrl: './cbc-string-cell-viewer.component.html',
  styleUrls: ['./cbc-string-cell-viewer.component.scss']
})
export class CbcStringCellViewerComponent implements OnInit, CellComponent {

  fieldDefinition: FieldDefinition;
  item: any;

  @Output() valueChanged: EventEmitter<any> = new EventEmitter();


  constructor() { }

  ngOnInit(): void {
  }

  onClicked(action: string) {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
  }

  openNote() {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, noteKey: `${this.fieldDefinition.key}_Detail` ,action: {id: 'OpenNote'}})
  }
}
